
export default function(){
    document.querySelector(".j-close-btn").addEventListener("click",()=>{
        document.querySelector(".j-dialog-page").style.display = "none";
    })
    
    document.querySelector(".j-dialog-bg").addEventListener("click",()=>{
        document.querySelector(".j-dialog-page").style.display = "none";
    })
    
    document.querySelector(".j-service").addEventListener("click",()=>{
        document.querySelector(".j-dialog-page").style.display = "block";
    })
}